// extracted by mini-css-extract-plugin
export var header = "_he-0";